import { FunctionBrick, registerBrick } from 'olympe';

export default class ArrayContains extends FunctionBrick {

    /**
     * Executed every time an input (value, array) gets updated.
     * Note that this method will _not_ be executed if an input value is undefined.
     * 
     * @protected
     * @param {BrickContext} context
     * @param {string} value
     * @param {string} array
     * @param {function(boolean)} setContains
     */
    onUpdate(context, [value, array], [setContains]) {
        try {

            const arrayValue = JSON.parse(array)
            setContains(arrayValue.includes(value))

        } catch (e) {
            console.error(`Error parsing the input data, ${e}`)
        }
    }
}

registerBrick('017f6a427997dd0b5911', ArrayContains);
